
import React from 'react';
import ProgressOverlay from 'APP_ROOT/components/common/ProgressOverlay';
import { strings } from 'APP_ROOT/localization';
import Events from 'APP_ROOT/components/common/events';
import lsUtil from 'APP_ROOT/components/common/lsUtil';

export default class Themes extends React.PureComponent {

    applyThemeChange = (theme) => {

        document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, {detail: { loadingPageMessage: strings.formatString(strings.app_theme_changing, this.labelForTheme(theme)) } }));
        setTimeout(() => {
            window.location.reload();
            lsUtil.setItem('raven.theme', theme);
        }, 2000);
    }

    labelForTheme = (theme) => {
        switch (theme) {
            case "light": return strings.prefs_theme_light;
            case "dark": return strings.prefs_theme_dark;
            default: return strings.prefs_theme_unknown;
        }
    }


    render() {
        
        const pending = false; // pending is not used for this widget (widget is a conversion/upgrade from legacy code)

        let selectedTheme = lsUtil.getItem('raven.theme');
        if (!selectedTheme) {
            selectedTheme = this.props.features.theme_selection ? this.props.features.theme_selection : 'light';
        }

        return (
            <div>
                <h3>{strings.account_colour_theme_header}</h3>
                <div>{strings.account_colour_theme_description}</div>
                <div className='setting-group-horiz'>
                    <div className='setting-group radio-group'>
                        <div>
                            <input type="radio" name="colourTheme" id="colourTheme:light"
                                value='light'
                                checked={selectedTheme === 'light'}
                                onChange={(event) => {
                                    this.applyThemeChange('light');
                                }}
                                disabled={pending}
                            />
                            <label htmlFor='colourTheme:light' disabled={pending}>{this.labelForTheme('light')}</label>
                        </div>
                        <div>
                            <input type="radio" name="colourTheme" id="colourTheme:dark"
                                value='dark'
                                checked={selectedTheme === 'dark'}
                                onChange={(event) => {
                                    this.applyThemeChange('dark');
                                }}
                                disabled={pending}
                            />
                            <label htmlFor='colourTheme:dark' disabled={pending}>{this.labelForTheme('dark')}</label>
                        </div>
                        { pending && <ProgressOverlay />}
                    </div>
                </div>
            </div>
        );
    }
}
